import AlloyWheelStandard from './Alloy_Wheel.jpg';
import AlloyWheelDiamond from './Alloy_Wheel_Diamond.jpg';
import AlloyWheelTwoTone from './Alloy_Wheel_TwoTone.jpg';

const Images = {
    AlloyWheelStandard,
    AlloyWheelDiamond,
    AlloyWheelTwoTone
};

export default Images;
